module.exports = __webpack_public_path__ + "img/12-12.f1db1870.jpeg";